export default (spell) => {
    return {
        type : 'SET_FAVOURITE_SPELLS',
        favSpells : spell
    }
}